import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/quickModeStudentAssign';
/**
 * コンテンツ配信画面のState型
 */
export interface IStudentAssignState {
	readonly searchListItem: Actions.ISearchListItem[];
	readonly searchLogFile: string;
	readonly searchExceldata: string;
}

/**
 * コンテンツ配信画面のState初期値
 */
const initialState: IStudentAssignState = {
	searchExceldata: '',
	searchListItem: [],
	searchLogFile: '',
};

/**
 * コンテンツ配信画面
 * @param state State
 * @param action アクション
 */
const quickModeStudentAssign = (state: IStudentAssignState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}

	if (isType(action, Actions.setSearchList)) {
		return {
			...state,
			searchListItem: action.payload.data,
		};
	}
	if (isType(action, Actions.setLogFile)) {
		return {
			...state,
			searchLogFile: action.payload.result,
		};
	}
	if (isType(action, Actions.setExcelFile)) {
		return {
			...state,
			searchExceldata: action.payload.excelResult,
		};
	}
	return state;
};

export default quickModeStudentAssign;



// WEBPACK FOOTER //
// ./src/reducers/quickModeStudentAssign.ts